import { countries } from '@/data/countries';

// ISO 3166-1 alpha-3 to alpha-2 mapping for common countries
const iso3ToIso2: Record<string, string> = {
  AFG: 'AF', ALB: 'AL', DZA: 'DZ', AND: 'AD', AGO: 'AO', ARG: 'AR', ARM: 'AM',
  AUS: 'AU', AUT: 'AT', AZE: 'AZ', BHR: 'BH', BGD: 'BD', BRB: 'BB', BLR: 'BY',
  BEL: 'BE', BLZ: 'BZ', BEN: 'BJ', BTN: 'BT', BOL: 'BO', BIH: 'BA', BWA: 'BW',
  BRA: 'BR', BRN: 'BN', BGR: 'BG', BFA: 'BF', BDI: 'BI', KHM: 'KH', CMR: 'CM',
  CAN: 'CA', CPV: 'CV', CAF: 'CF', TCD: 'TD', CHL: 'CL', CHN: 'CN', COL: 'CO',
  COG: 'CG', COD: 'CD', CRI: 'CR', HRV: 'HR', CUB: 'CU', CYP: 'CY', CZE: 'CZ',
  DNK: 'DK', DJI: 'DJ', DOM: 'DO', ECU: 'EC', EGY: 'EG', SLV: 'SV', GNQ: 'GQ',
  ERI: 'ER', EST: 'EE', SWZ: 'SZ', ETH: 'ET', FJI: 'FJ', FIN: 'FI', FRA: 'FR',
  GAB: 'GA', GMB: 'GM', GEO: 'GE', DEU: 'DE', GHA: 'GH', GRC: 'GR', GTM: 'GT',
  GIN: 'GN', GNB: 'GW', GUY: 'GY', HTI: 'HT', HND: 'HN', HUN: 'HU', ISL: 'IS',
  IND: 'IN', IDN: 'ID', IRN: 'IR', IRQ: 'IQ', IRL: 'IE', ISR: 'IL', ITA: 'IT',
  JAM: 'JM', JPN: 'JP', JOR: 'JO', KAZ: 'KZ', KEN: 'KE', KWT: 'KW', KGZ: 'KG',
  LAO: 'LA', LVA: 'LV', LBN: 'LB', LSO: 'LS', LBR: 'LR', LBY: 'LY', LIE: 'LI',
  LTU: 'LT', LUX: 'LU', MDG: 'MG', MWI: 'MW', MYS: 'MY', MDV: 'MV', MLI: 'ML',
  MLT: 'MT', MRT: 'MR', MUS: 'MU', MEX: 'MX', MDA: 'MD', MCO: 'MC', MNG: 'MN',
  MNE: 'ME', MAR: 'MA', MOZ: 'MZ', MMR: 'MM', NAM: 'NA', NPL: 'NP', NLD: 'NL',
  NZL: 'NZ', NIC: 'NI', NER: 'NE', NGA: 'NG', PRK: 'KP', MKD: 'MK', NOR: 'NO',
  OMN: 'OM', PAK: 'PK', PAN: 'PA', PNG: 'PG', PRY: 'PY', PER: 'PE', PHL: 'PH',
  POL: 'PL', PRT: 'PT', QAT: 'QA', ROU: 'RO', RUS: 'RU', RWA: 'RW', SAU: 'SA',
  SEN: 'SN', SRB: 'RS', SLE: 'SL', SGP: 'SG', SVK: 'SK', SVN: 'SI', SOM: 'SO',
  ZAF: 'ZA', KOR: 'KR', ESP: 'ES', LKA: 'LK', SDN: 'SD', SUR: 'SR', SWE: 'SE',
  CHE: 'CH', SYR: 'SY', TWN: 'TW', TJK: 'TJ', TZA: 'TZ', THA: 'TH', TGO: 'TG',
  TTO: 'TT', TUN: 'TN', TUR: 'TR', TKM: 'TM', UGA: 'UG', UKR: 'UA', ARE: 'AE',
  GBR: 'GB', USA: 'US', URY: 'UY', UZB: 'UZ', VEN: 'VE', VNM: 'VN', YEM: 'YE',
  ZMB: 'ZM', ZWE: 'ZW',
};

/**
 * Resolves a country code (ISO2 or ISO3) or name to a full country name.
 * Returns the original value if no match is found.
 */
export function resolveCountryName(value: string | undefined | null): string {
  if (!value) return '';
  const v = value.trim().toUpperCase();

  // Check ISO3 → ISO2 first
  const iso2 = iso3ToIso2[v];
  if (iso2) {
    const found = countries.find(c => c.code === iso2);
    return found?.name ?? value;
  }

  // Check direct ISO2 match
  const direct = countries.find(c => c.code === v);
  if (direct) return direct.name;

  // Already a name? Return as-is
  const byName = countries.find(c => c.name.toUpperCase() === v);
  if (byName) return byName.name;

  return value;
}
